export default __webpack_public_path__ + "static/media/style-beast-hero-image.09c77dd3.svg";